// src/pages/EstudiosDeMercado.js

import React, { useEffect, useRef } from 'react';
import { FiPieChart } from 'react-icons/fi';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion, useScroll, useTransform } from 'framer-motion';

import '../styles/EstudiosDeMercado.css';
import portadaImg from '../assets/images/portada.webp';

const EstudiosDeMercado = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-in-out',
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="estudios-page-container" ref={containerRef}>
      <motion.div
        className="estudios-background-image"
        style={{
          backgroundImage: `url(${portadaImg})`,
          y: parallaxY
        }}
      />
      <div className="container-estudios" data-aos="fade-up">
        <div className="construction-content">
          <div className="construction-icon-wrapper">
            <FiPieChart className="construction-icon" />
          </div>
          <h1 className="construction-title">Análisis y Estadísticas del Sector</h1>
          <p className="construction-subtitle">Sección en Construcción</p>
          <p className="construction-description">
            Estamos trabajando para darte acceso a una plataforma interactiva con informes de mercado, 
            estadísticas clave y análisis de tendencias que te ayudarán a tomar las mejores decisiones estratégicas.
            ¡Vuelve pronto para descubrirla!
          </p>
        </div>
      </div>
    </div>
  );
};

export default EstudiosDeMercado;